export class ListarDocumentos {
  centro_costo: any;
  centro_logistico: any;
  correo_proveedor: any;
  descuento?: number;
  emisor_nombre?: string;
  emisor_rfc?: string;
  estatus?: string;
  estatus_cancelacion: any;
  estatus_fiscal?: number;
  estatus_negocio?: number;
  estatus_pago?: number;
  estatus_sap?: number;
  estatus_sat?: string;
  fecha?: string;
  fecha_actualizacion: any;
  fecha_creacion?: string;
  fecha_timbrado?: string;
  folio?: string;
  folio_sap?: string;
  forma_pago?: string;
  id?: number;
  id_centro_costo?: number;
  id_centro_logistico?: number;
  id_estatus: any;
  id_tipo_documento_negocio: any;
  id_usuario: any;
  identificador?: string;
  metodo_pago?: string;
  moneda?: string;
  numero_codigo_recepcion?: string;
  numero_pedido?: string;
  numero_proveedor?: string;
  pagada: boolean;
  receptor_nombre?: string;
  receptor_rfc?: string;
  referencia: any;
  ruta_pdf?: string;
  ruta_xml?: string;
  serie?: string;
  subtotal?: number;
  tipo_cambio?: string;
  tipo_comprobante?: string;
  tipo_documento_negocio?: string;
  total?: number;
  total_impuestos_locales_retenidos: any;
  total_impuestos_locales_trasladados: any;
  total_impuestos_retenidos?: number;
  total_impuestos_trasladados?: number;
  uso_cfdi?: string;
  usuario?: string;
  usuario_actualizacion: any;
  usuario_creacion?: string;
  uuid?: string;
  version?: string;
  constructor(){
    this.pagada = false;
  }
}

export class FiltroListarDocumentos {
  codigo_recepcion?: string;
  estatus_sat?: string;
  fecha_carga_desde?: string;
  fecha_carga_hasta?: string;
  fecha_desde?: string;
  fecha_hasta?: string;
  folio?: string;
  folio_sap?: string;
  forma_pago?: string;
  identificador_empresa?: string;
  metodo_pago?: string;
  moneda?: string;
  numero_pedido?: string;
  numero_proveedor?: string;
  rfc_emisor?: string;
  rfc_receptor?: string;
  serie?: string;
  tipo_comprobante?: string;
  usuario?: string;
  uuid?: string;
  version?: string;
}
